import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import { BrowserRouter, useNavigate } from "react-router";
import "./index.css";
import App from "./App";
import { taitoraMarkUri } from "./assets/brand/logoUri";

const publishableKeyEnv = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;
if (!publishableKeyEnv) {
  throw new Error("VITE_CLERK_PUBLISHABLE_KEY is not set — add it to your .env file");
}
const publishableKey: string = publishableKeyEnv;

const root = document.getElementById("root");
if (!root) throw new Error("#root element not found");

// ClerkProvider lives inside the router so Clerk's internal navigation (e.g.
// after sign-in, or between SignIn/SignUp) is client-side rather than a reload.
function ClerkWithRouter() {
  const navigate = useNavigate();
  return (
    <ClerkProvider
      publishableKey={publishableKey}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      appearance={{
        layout: {
          logoImageUrl:  taitoraMarkUri,
          logoLinkUrl:   "/",
          logoPlacement: "inside",
        },
        variables: {
          colorPrimary:        "#D8943C",
          colorBackground:     "#F6F2EA",
          colorText:           "#111318",
          colorTextSecondary:  "#7F8A96",
          colorInputBackground:"#ffffff",
          borderRadius:        "8px",
          fontFamily:          "Inter, system-ui, sans-serif",
        },
      }}
    >
      <App />
    </ClerkProvider>
  );
}

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <ClerkWithRouter />
    </BrowserRouter>
  </StrictMode>
);
